import { render, staticRenderFns } from "./WorkspaceTopbar.vue?vue&type=template&id=9ec3090a&scoped=true&"
import script from "./WorkspaceTopbar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceTopbar.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceTopbar.vue?vue&type=style&index=0&id=9ec3090a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec3090a",
  null
  
)

export default component.exports